export default "https://cdn-static.gokick.com/assets/46c46890c219de5164704b27b734f3ae915944d1/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";